import { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { Close, Cookie } from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ type: "spring", stiffness: 120, damping: 20 }}
          style={{
            position: "fixed",
            top: "40%",
            left: "5%",
            transform: "translate(-50%, -50%)",
            zIndex: 5000,
            width: "90%",
            maxWidth: 480,
          }}
        >
          <Box
            sx={{
              background: "linear-gradient(135deg, #181818 0%, #232323 100%)",
              color: "#fff",
              borderRadius: 3,
              p: 4,
              display: "flex",
              flexDirection: "column",
              gap: 3,
              alignItems: "center",
              boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
            }}
          >
            {/* Icon */}
            <Cookie sx={{ fontSize: 50, color: "#C6A972" }} />

            {/* Text */}
            <Box textAlign="center">
              <Typography
                sx={{
                  fontFamily: "Playfair Display",
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  mb: 1,
                }}
              >
                We Use Cookies
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "0.8rem",
                  lineHeight: 1.6,
                  color: "rgba(255,255,255,0.85)",
                }}
              >
                Helvetia uses cookies to ensure the best experience for our fans
                and clients. By continuing, you agree to our use of cookies.
              </Typography>
            </Box>

            {/* Actions */}
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <Button
                onClick={handleAccept}
                variant="contained"
                sx={{
                  backgroundColor: "#C6A972",
                  color: "#111",
                  textTransform: "uppercase",
                  fontWeight: 700,
                  borderRadius: 2,
                  "&:hover": { backgroundColor: "#B28F5F" },
                }}
              >
                Accept
              </Button>

              <IconButton
                onClick={handleClose}
                sx={{ color: "rgba(255,255,255,0.7)" }}
              >
                <Close />
              </IconButton>
            </Box>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
